import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowBoxLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowBoxLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3L12 3V4.5L4.5 4.5L4.5 19.5H12V21H3L3 3ZM15.75 6.43934L21.3107 12L15.75 17.5607L14.6893 16.5L18.4393 12.75L8.25 12.75V11.25L18.4393 11.25L14.6893 7.5L15.75 6.43934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowBoxLeft;
